import React from 'react'
import { Input } from '@material-ui/core';
import  Button  from '@material-ui/core/Button';
import "./CreateAccount.css"


function CreateAccount( {username, setUsername, email, setEmail, password, setPassword, signUp } ) {

    
    return (
        <div
        >
          <form className="App_signup"> 

            <center>
              <img 
              className="app_headerImage"
              src ="https://www.instagram.com/static/images/web/mobile_nav_type_logo.png/735145cfe0a4.png"
              alt=""
              />
            </center>

              <Input 
              placeholder="username"
              type="text" 
              value={username} 
              onChange={(e) => setUsername(e.target.value)} 
              />
              <Input 
              placeholder="email"
              type="text" 
              value={email} 
              onChange={(e) => setEmail(e.target.value)} 
              />
              <Input 
              placeholder="password"
              type="password" 
              value={password} 
              onChange={(e) => setPassword(e.target.value)}
              />

              <Button type="submit" onClick={signUp}>Sign Up</Button>
            </form>

        </div>
    )
}

export default CreateAccount
